import React from "react";
import { useDispatch } from "react-redux";
import { MainModal } from "../../../../components/modal/MainModal";
import { deleteRegion } from "../redux/regionsSagas";

export const Delete = ({ isOpen, onClose, selectedRegion: { id, name } = {} }) => {
  const dispatch = useDispatch();

  const primaryBtnHandler = () => {
    dispatch(deleteRegion(id));
    onClose();
  };

  return (
    <MainModal
      parentSelector=".regions"
      isOpen={isOpen}
      onClose={onClose}
      headerText="Delete"
      headerCloseHandler={onClose}
      width={300}
      height="auto"
      primaryButtonText="Delete"
      primaryBtnHandler={primaryBtnHandler}
      primaryButtonClass="critical"
      secondaryBtnText="Cancel"
      secondaryBtnHandler={onClose}
      containerClassName="dialog"
    >
      Are you sure to delete <span className="text-bold">{name}</span> region?
    </MainModal>
  );
};
